import { render } from "./ListPage2.vue?vue&type=template&id=f6fcd53c&scoped=true"
import script from "./ListPage2.vue?vue&type=script&lang=js"
export * from "./ListPage2.vue?vue&type=script&lang=js"

import "./ListPage2.vue?vue&type=style&index=0&id=f6fcd53c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6fcd53c"]])

export default __exports__